import { render, staticRenderFns } from "./ProductGet.vue?vue&type=template&id=56568c77&"
import script from "./ProductGet.vue?vue&type=script&lang=js&"
export * from "./ProductGet.vue?vue&type=script&lang=js&"
import style0 from "./ProductGet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports